module.exports = __webpack_public_path__ + "img/999999956.3c5a08b7.png";